var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7972 6.33333V9M14.7972 9V11.6667M14.7972 9H17.4639M14.7972 9H12.1305M10.3528 4.55556C10.3528 5.49855 9.97815 6.40292 9.31136 7.06971C8.64456 7.73651 7.74019 8.11111 6.7972 8.11111C5.85421 8.11111 4.94984 7.73651 4.28304 7.06971C3.61625 6.40292 3.24164 5.49855 3.24164 4.55556C3.24164 3.61256 3.61625 2.70819 4.28304 2.0414C4.94984 1.3746 5.85421 1 6.7972 1C7.74019 1 8.64456 1.3746 9.31136 2.0414C9.97815 2.70819 10.3528 3.61256 10.3528 4.55556ZM1.46387 16.1111C1.46387 14.6966 2.02577 13.3401 3.02596 12.3399C4.02616 11.3397 5.38271 10.7778 6.7972 10.7778C8.21169 10.7778 9.56824 11.3397 10.5684 12.3399C11.5686 13.3401 12.1305 14.6966 12.1305 16.1111V17H1.46387V16.1111Z",
    stroke: "#75C594",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementIcon);
export default __webpack_public_path__ + "static/media/engagement-icon.98617240cd567506d1d01c55596104e0.svg";
export { ForwardRef as ReactComponent };